// extracted by mini-css-extract-plugin
export default {"container":"modal_confirmation_footer-module__container--2lPaA"};